export default "__VITE_ASSET__h99VlUYN__"